import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { environment } from '@env/environment';
import { GlobalsService } from "@app/cp/shared/services/globals.service";
import { routerTransitions } from "@app/shared/utils/animations";
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { Router } from "@angular/router"; // <-- Add this import

@Component({
    selector: "app-main-layout",
    templateUrl: "./main-layout.component.html",
    styles: [],
    animations: [routerTransitions]
})
export class MainLayoutComponent implements OnInit, AfterViewInit {

    envType = environment.deployment;
    envBannerClass = this.getEnvBannerClass(environment.deployment);
    envVars = !environment.production;
    envApiLoc = environment.APIEndPoint;
    envApiCLoc = environment.APICEndPoint;
    public
    public isBirthday: Boolean = false;
    public eventText: string = '';
    public eventSubText: string = '';
    public eventClass: string = '';
    public featureFlagSet: any = {};
    public isPopout: boolean = false;

    constructor(private globals: GlobalsService, private changeRef: ChangeDetectorRef, protected featureFlagService: FeatureFlagService, private router: Router) {
        this.featureFlagService.featureFlagSets.subscribe(data => {
            this.featureFlagSet = data;
        });
    }

    ngOnInit() {
        this.checkForEvent();
        this.isPopout = this.router.url.includes('/popout/');
    }

    ngAfterViewInit() {
        this.changeRef.detectChanges();

    }

    getEnvBannerClass(deployment: string): string {
        const normalizedDeployment = (deployment || '').toLowerCase();
        return normalizedDeployment.startsWith('rd') ? 'next' : normalizedDeployment;
    }

    getState(outlet) {
        if (!outlet.isActivated) {
            return null;
        }
        let ss = outlet.activatedRoute.snapshot;

        // return unique string that is used as state identifier in router animation
        return (
            outlet.activatedRouteData.state ||
            (ss.url.length ? ss.url[0].path : ss.parent.url.length ? ss.parent.url[0].path : null)
        );
    }

    checkForEvent() {
        //TODO BW: Expand to include other holidays
        if (localStorage.getItem("showEvent") != 'hide') {
            this.isBirthday = this.globals.user.isBirthday;
            if (this.isBirthday == true) {
                this.eventClass = 'birthday';
                this.eventText = 'Happy Birthday!';
                this.eventSubText = 'from Climate Pros to you';
                localStorage.setItem("showEvent", "show");
            }
        } else {
            this.isBirthday = false;
        }
    }

    closeEvent() {
        this.isBirthday = false;
        console.log(localStorage.getItem("showEvent"));
        localStorage.setItem("showEvent", "hide");
        console.log(localStorage.getItem("showEvent"));
    }

    public newGridStyles: any = false;
    checkForGridCSSFeatureFlag() {
        this.newGridStyles = this.featureFlagService.LdIsFeatureEnabled('kendo-grid-edit-template-css-change');
        console.log('newGridStyles', this.newGridStyles);
    }

}
